import React from 'react';

import './Style.css';

class Sumario extends React.Component {

    /**
     * Formata a data do período.
     *
     * Exemplo:
     * 2026-09-01 -> 09/2026
     */
    formatPeriod = (period) => {
        if (!period) {
            return '-';
        }

        const date = new Date(period);

        if (Number.isNaN(date.getTime())) {
            return period;
        }

        return date.toLocaleDateString(
            'pt-BR',
            {
                month: '2-digit',
                year: 'numeric',
            }
        );
    };

    /**
     * Garante que a porcentagem seja válida.
     */
    getPercentage = (value) => {
        const percentage = Number(value);

        if (Number.isNaN(percentage)) {
            return 0;
        }

        return Math.min(
            Math.max(percentage, 0),
            100
        );
    };

    renderProgress = (title, data) => {
        const total = data?.total ?? 0;
        const concluido = data?.concluido ?? 0;
        const percentage = this.getPercentage(data?.porcentagem_concluido);

        return (
            <div className="item">
                <div className="flex justify-content-between">
                    <h5>{title}</h5>
                    <span>{concluido}/{total} ({percentage}%)</span>
                </div>
                <div className="progresso">
                    <span style={{ width: `${percentage}%`, }} />
                </div>
            </div>
        );
    };

    render() {
        const {
            cityPeriod,
            countBuildingsFromPeriod,
            onShowModalDemerito,
            onShowVariations,
        } = this.props;

        const city = cityPeriod?.city?.city ?? '-';
        const state = cityPeriod?.city?.state ?? '-';
        const analyst = cityPeriod?.city?.analista?.name ?? '-';
        const period = this.formatPeriod( cityPeriod?.period );
        const ativo = countBuildingsFromPeriod?.ativo ?? {};
        const futuro = countBuildingsFromPeriod?.futuro ?? {};

        return (
            <div className='row'>
                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12">
                    <table className="table table-striped table-sm table-informacao-analista">
                        <tbody>
                            <tr>
                                <td className="text-left">
                                    <strong>Analista</strong>
                                </td>
                                <td>{analyst}</td>
                            </tr>
                            <tr>
                                <td className="text-left">
                                    <strong>Periodicidade</strong>
                                </td>
                                <td>{cityPeriod?.city?.follow_up_period == 3 ? 'Trimestral' : 'Mensal'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12">
                    <div className="atualizacoes">
                        <h4>
                            Atualização da base da cidade de{' '}
                            {city}/{state}
                            {' '}no período {period}
                        </h4>
                        {this.renderProgress(
                            'Ativos',
                            ativo
                        )}
                        {this.renderProgress(
                            'Futuros',
                            futuro
                        )}
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12">
                    <div className="buttons-group">
                        <button
                            type="button"
                            className="btn btn-sm btn-block btn-primary button-brain btn-round"
                            onClick={onShowModalDemerito}
                        >
                            Adicionar demérito
                        </button>
                        <a
                            role="button"
                            className="btn btn-success btn-sm btn-block btn-round background-brain border-brain"
                            href={`/validacao-empreendimentos/${cityPeriod.id}`}
                        >
                            Rodar validação
                        </a>
                        <button
                            type="button"
                            className="btn btn-default btn-block btn-round"
                            onClick={onShowVariations}
                        >
                            <i className="fa fa-line-chart"></i>
                            {' '}
                            Ver Variações
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Sumario;